export default { 
    bind: function (el, binding, vnode) {
        el.addEventListener('keypress', (event) => {
            if(event.key == "Enter"){
                event.preventDefault();
                binding.value.call();
            }
        });
    },  
    unbind(el, binding, vnode){
        el.removeEventListener('keypress', (event) => {
            if(event.key == "Enter"){
                event.preventDefault();
                binding.value.call();
            }
        });    
    }
} 